// extracted by mini-css-extract-plugin
export var addressFields = "_j1-0";
export var animationContainer = "_j1-1";
export var footer = "_j1-2";
export var lineItems = "_j1-3";
export var modalContent = "_j1-4";
export var orderName = "_j1-5";
export var strong = "_j1-6";
export var warning = "_j1-7";